import { Action } from 'redux';
import { ActionsObservable } from 'redux-observable';
import { of } from 'rxjs';
import {
  filter,
  map,
  mergeMap,
  tap,
} from 'rxjs/operators';
import * as api from 'api/user';
import { API_URL } from 'constants/baseUrl';
import { catchError } from '#shared/utils/apiHelpers';

import {
  getInfoError,
  getInfoRequest,
  getInfoSuccess,
  loginRequest,
} from './slice';

export const userLoginEpic = (
  action$: ActionsObservable<Action>,
) => {
  return action$.pipe(
    filter(loginRequest.match),
    tap(() => {
      // TODO: epic is not used, because strange behavior of browser, when doing navigation from epic.
      //  On localhost everything is fine
      const baseUrl = API_URL || window.location.origin;
      window.location.replace(`${baseUrl}/process-list`);
    }),
  );
};

export const getUserInfoEpic = (
  action$: ActionsObservable<Action>,
) => {
  return action$.pipe(
    filter(getInfoRequest.match),
    mergeMap(() => {
      return api.getInfo().pipe(
        map(({ response }) => getInfoSuccess(response)),
        catchError((error) => of(getInfoError({ httpStatus: error.status }))),
      );
    }),
  );
};
